<template>
  <div class="popup_in">
    <div class="popup">
      <div class="popup_close close-animate">
        <a href="javascript:void(0);" @click.prevent="$emit('close')"
          ><CloseSvg
        /></a>
      </div>
      <div v-if="isSurg && !type" class="title">
        מחיקת הניתוח הינה סופית. <br />
        האם למחוק את הניתוח?
      </div>
      <div v-else-if="isSurg && type" class="title">
        <!-- מחיקת הניתוח הינה סופית. <br /> -->
        לאחר אישורך, הניתוח יוחזר לשיבוץ מחדש
      </div>
      <div v-else class="title">
        ביטול התור הינו סופי.<br />
        האם לבטל את התור?
      </div>
      <div class="flex flex--content--center">
        <a
          class="bt_blue mt-30"
          href="javascript:void(0)"
          @click.prevent="cancelApp"
        >
          {{ btnText }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import CloseSvg from "../../assets/img/svg/close.svg";
import Error from "@/components/Popups/Error";
import { getHash } from "../../utilities/hash.js";
import { isMobile } from "../../utilities/globals";

export default {
  name: "CancelApp",
  props: {
    isSurg: { type: Boolean, default: false },
    appointment_id: { required: true },
    appDate: { default: false },
    type: { default: false },
    openOnCalendar: { default: false },
    parentFunc: { default: undefined }
  },
  computed: {
    btnText() {
      if (this.isSurg) {
        if (this.type) return "אישור";
        else return "מחיקת ניתוח";
      } else {
        return "ביטול תור";
      }
    }
  },
  methods: {
    async cancelApp() {
      if (this.isSurg) {
        try {
          await this.$API.deleteSurgery(this.appointment_id, this.type);
          this.$emit("close");
          if (
            this.$router.prevRoute &&
            this.$router.prevRoute.path.includes("table")
          ) {
            this.$router.go(-1);
            return;
          }
          if (!this.openOnCalendar) this.$router.go(-1);
          else this.$root.$emit("rescheduleSurgery");
        } catch (error) {
          this.$emit("close");
          this.$modal.show(Error);
        }
      } else {
        try {
          await this.$API.cancelAppointment(this.appointment_id);
          this.$emit("close");
          if (
            this.$router.prevRoute &&
            this.$router.prevRoute.path.includes("table")
          ) {
            this.$router.go(-1);
            return;
          }
          let hash = getHash({ day: this.appDate, view: "day" });
          if (this.$route.name == "Dashboard") {
            this.$root.$emit("refreshBlock");
            this.$emit("close");
          } else {
            this.$router.push("/dashboard#" + hash);
          }
        } catch (e) {
          this.$emit("close");
          this.$modal.show(Error);
        }
      }
    }
  },
  components: {
    CloseSvg
  }
};
</script>

<style scoped></style>
